import React from 'react';
import Slide from 'react-reveal/Slide';


const MyBlogDetails = ({ blogs }) => {
    return (
       <Slide right>
            <div className="col-md-4 card mx-auto" style={{width: "20rem"}}>
                <img className="card-img-top" src={blogs.blogImage} alt="" />
            <div className="card-body">
                <h6 className="card-title">{blogs.name}</h6>
                <a href={blogs.link} className="btn btn-warning fw-bold me-2 mb-2" target="_blank">Read More</a>
            </div>

        </div>
       </Slide>
    );
};

export default MyBlogDetails;